import React, { useState } from 'react';
import { createIntegrationAccessToken } from 'flow/actions/integration-access-actions';
import SettingSection from 'flow/components/Setting/SettingSection';
import BaseModal from 'flow/components/ui-components/BaseModal';
import Divider from 'flow/components/ui-components/Divider';
import InputField from 'flow/components/ui-components/InputField';
import RadioButton from 'flow/components/ui-components/RadioButton';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { selectDomains } from 'flow/selectors/integration-access-selectors';
import {
    ExtensionKey,
    IntegrationAccessDomainKey,
} from 'flow/types/EntityKeys';

interface Props {
    extensionKey?: ExtensionKey;
}

const CreateTokenModal = ({ extensionKey }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const { openModal } = useModal();

    const [domainKey, setDomainKey] = useState<IntegrationAccessDomainKey>();
    const [description, setDescription] = useState<string>();

    const domains = useAppSelector(selectDomains);

    const createToken = () => {
        dispatch(
            createIntegrationAccessToken(extensionKey, domainKey, description),
        );

        openModal('createTokenSuccess');
    };

    return (
        <BaseModal
            open={true}
            header={i18next.t('settings.integrations.create_new_token')}
            onContinue={createToken}
            confirmButtonText={i18next.t('settings.integrations.create_token')}
            disableSubmit={!domainKey}
            className="w-[600px]"
        >
            <SettingSection>
                {i18next.t('settings.integrations.where_use_token')}
            </SettingSection>

            {domains
                .map((domain) => (
                    <RadioButton
                        key={domain.get('key')}
                        name="domainOptions"
                        checked={domain.get('key') === domainKey}
                        onChange={() => setDomainKey(domain.get('key'))}
                    >
                        {domain.get('domainName')}
                    </RadioButton>
                ))
                .toArray()}

            <Divider />

            <SettingSection>
                {i18next.t('settings.integrations.name_the_token')}
            </SettingSection>

            <div className="px-2">
                <InputField
                    defaultValue={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
            </div>
        </BaseModal>
    );
};

export default CreateTokenModal;
